<template>
  <div>
    <template v-if="isSupported">
      <component
        :is="isSupported"
        :field="field"
        :value="value"
        @input="onChange"
      ></component>
      <!-- <singleText :field="field" :value="value" @input="onChange" /> -->
    </template>
    <template v-else>
      <a-alert message="Chưa hỗ trợ kiểu dữ liệu này!" banner />
    </template>
  </div>
</template>
<script>
export default {
  components: {
    singleText: () => import("./SingleText.vue"),
    multilineText: () => import("./MultilineText.vue"),
    number: () => import("./Number.vue"),
    choice: () => import("./Choice.vue"),
    users: () => import("./Users.vue"),
  },
  props: {
    field: {
      type: Object,
      required: true,
    },
    value: [Number, String, Array],
  },
  data() {
    return {
      typeFields: ["singleText", "multilineText", "number", "choice", "users"],
    };
  },
  computed: {
    // Kiểm tra có hỗ trợ kiểu này ko, nếu có thì return tên com của kiểu
    isSupported() {
      if (this.field && this.field.type) {
        const fiedName = this.typeFields.find((e) => e === this.field.type);
        if (fiedName && typeof fiedName === "string") {
          return fiedName;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
  },
  methods: {
    onChange(event) {
      this.$emit("input", event);
    },
  },
};
</script>
